import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Styles from "./edit.module.css";
import { Services } from "Services";
import { AiOutlineClose } from "react-icons/ai";
import { SuccessSwal, warningSwal } from "Util/Toast";

Modal.setAppElement("#root");

const StudentEdit = ({ modal, setModal, studentData, getscheduledClasses }) => {
    const [editValues, setEditValues] = useState({ Age: "", Months: "", About: "" });
    const [loading, setLoading] = useState(false);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        if (studentData) {
            setEditValues({
                Age: studentData.Age || "",
                Months: studentData.Months || "",
                About: studentData.About || ""
            });
        }
    }, [studentData, modal]);

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditValues((prev) => ({ ...prev, [name]: value }));
    };

    const closeModal = () => {
        setModal(false);
    };

    const onSubmit = async () => {
        setLoading(true);
        try {
            const response = await Services.EditDemoClassStudent(
                "PUT",
                JSON.stringify({
                    Age: editValues.Age,
                    Months: editValues.Months,
                    About: editValues.About,
                }),
                token,
                studentData.DemoStudentID
            );

            if (response?.Status == 1) {
                SuccessSwal("Success", response.Message || "Updated successfully");
                getscheduledClasses();
                closeModal();
            } else {
                warningSwal("Warning", response.Message || "Update failed");
            }
        } catch (error) {
            console.error("Error updating student:", error);
            warningSwal("Error", "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={modal}
            contentLabel="Edit Student Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}
        >
            <div className={Styles["form-wrapper"]}>
                <button className={Styles["close-btn"]} onClick={closeModal}>
                    <AiOutlineClose />
                </button>
                <h2>Edit Student Details</h2>
                
                <div className={Styles["age-container"]}>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="Age">Age (Years)</label>
                        <input
                            type="number"
                            id="Age"
                            name="Age"
                            value={editValues.Age}
                            onChange={handleEditChange}
                            placeholder="Age"
                        />
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="Months">Months</label>
                        <input
                            type="number"
                            id="Months"
                            name="Months"
                            value={editValues.Months}
                            onChange={handleEditChange}
                            placeholder="Months"
                        />
                    </div>
                </div>

                <div className={Styles["form-control"]}>
                    <label htmlFor="About">About</label>
                    <textarea
                        id="About"
                        name="About"
                        value={editValues.About}
                        onChange={handleEditChange}
                        rows={4}
                        placeholder="Write about student..."
                        style={{ resize: "vertical" }}
                    />
                </div>

                <div className={Styles["buttons"]}>
                    <button
                        className={Styles["submit"]}
                        onClick={onSubmit}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save Details"}
                    </button>
                    <button className={Styles["close"]} onClick={closeModal}>
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default StudentEdit;
